module.exports = __webpack_public_path__ + "img/bank-16-kdb.98dc28fc.svg";